import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

// Async function to call the delete endpoint
const removeFightFromEvent = async (
  eventId,
  fightId,
  getAccessTokenSilently
) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  await axios.delete(
    `${apiUrl}/api/events/remove-fight/${eventId}/${fightId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// Custom hook
export const useRemoveFightFromEvent = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(
    ({ eventId, fightId }) =>
      removeFightFromEvent(eventId, fightId, getAccessTokenSilently),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("eventDetails");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message || "Failed to remove fight from event.";
        toast.error(errorMessage);
        console.error("Error removing fight from event:", error);
      },
    }
  );
};
